<template>
  <div class="wrapper">
    <div class="grid">
      <div>
        <div class="logo"><img src="@/assets/obwan-logo-transparent.png" alt=""></div>
        <div class="box">
          <h1>Restricted access</h1>
          <p>Please sign-in.</p>
          <button class="block" @click="login()">Sign-in</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { login } from '../utils/auth';
export default {
  name: 'Authorize',
  methods: {
    login() {
      login();
    }
  }
}
</script>

<style lang="scss" scoped>
  .logo {
    width: 100%;
    text-align: center;
    margin-top: 15vh;
    img {
      height: 40px;
      display: inline-block;
      text-align: center;
    }
  }
  .box {
    background-color: #393C44;
    border: 1px solid #4B505C;
    border-radius: 5px;
    padding: 15px 20px 20px 20px;
    width: calc(40% - 40px);
    margin: 5vh auto 0 auto;

    @media screen and (max-width: 800px) {
      width: calc(100% - 40px);
    }

    h1{
      font-size: 24px;
      font-weight: 600;
      margin: 0 0 8px 0;
    }
    p{
      font-size: 12px;
      font-weight: 400;
      margin: 0 0 5vh 0;
    }
  }
</style>

